var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutUsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 234,
    viewBox: "0 0 472 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 234,
    rx: 8,
    fill: "url(#paint0_radial_251_6227)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 234,
    rx: 8,
    fill: "url(#paint1_radial_251_6227)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.813 212.189L258.522 136.5L292.959 196.141C276.381 208.107 256.446 214.532 236 214.5C228.726 214.5 221.638 213.701 214.813 212.189ZM195.927 205.92C183.401 200.256 172.21 192.014 163.084 181.732C153.958 171.451 147.103 159.36 142.965 146.25H230.374L195.927 205.91V205.92ZM138.987 126.75C137.592 113.073 139.116 99.2562 143.457 86.2119C147.798 73.1676 154.859 61.1933 164.172 51.0804L207.842 126.75H138.987ZM179.05 37.8594C195.626 25.8949 215.557 19.4698 236 19.5001C243.273 19.5001 250.362 20.2996 257.187 21.8109L213.477 97.5001L179.05 37.8594ZM276.072 28.0801C288.599 33.7437 299.791 41.9854 308.917 52.2672C318.043 62.5489 324.898 74.6396 329.034 87.7501H241.626L276.072 28.0801ZM333.012 107.25C334.408 120.927 332.884 134.744 328.543 147.788C324.202 160.833 317.141 172.807 307.828 182.92L264.158 107.25H333.032H333.012Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_251_6227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.10535e-05 234) rotate(-25.5409) scale(412.844 774.519)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C71A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EB2D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B04FB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_251_6227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-79.0618 16.8562) rotate(68.0136) scale(109.622 815.099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2304FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2304FB",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsLogo);
export default __webpack_public_path__ + "static/media/aboutUsLogo.ad9d3d7fbdfca8d28733df67fad6f551.svg";
export { ForwardRef as ReactComponent };